import { linkToTeacherDashboard } from "../../links";

export function linkToProgress() {
  return `${linkToTeacherDashboard()}/progress`;
}

export function linkToProgressReportModal(requestId: string = ":requestId?") {
  return `${linkToProgress()}/report/${requestId}`;
}
